export default __webpack_public_path__ + "static/media/2000.1cdc2ec2.png";